import '@mercedes-benz/typeface-mb-corpo-a';
import '@mercedes-benz/typeface-mb-corpo-s';
import 'normalize.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { DataService } from '../shared/auth/DataService';
import { AccessDeniedPage } from '../shared/ui/AccessDeniedPage';
import { LicenseInfo } from '@mui/x-license';
import '../index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));

LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_LICENSE);

await DataService.ChecklogIn();

DataService.getAuth().then(async () => {
  if (DataService.authorized() === true) {
    const bootstrapOk = await DataService.bootstrapUser();
    if (!bootstrapOk) {
      localStorage.setItem(
        'auth.lastError',
        sessionStorage.getItem('bootstrap.error') ||
          'User provisioning failed. Please contact your administrator.'
      );
      root.render(
        <React.StrictMode>
          <AccessDeniedPage />
        </React.StrictMode>
      );
    } else {
      root.render(
        <React.StrictMode>
          <App />
        </React.StrictMode>
      );
    }
  } else if (DataService.isUnauthorized()) {
    root.render(
      <React.StrictMode>
        <AccessDeniedPage />
      </React.StrictMode>
    );
  }

  reportWebVitals();
});
